import { render, staticRenderFns } from "./AddEditScientificDegree.vue?vue&type=template&id=03813a48"
import script from "./AddEditScientificDegree.vue?vue&type=script&lang=js"
export * from "./AddEditScientificDegree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports